import { Explainer } from '@vnetwork/ui/primitives';

/**
 * WAF/Firewall "How the edge evaluates a request" explainer — the 10-stage edge
 * pipeline content, rendered in the shared `Explainer` primitive. The request
 * pipeline *diagram* lives in the design system — import `FlowDiagram` from
 * `@vnetwork/ui/data`.
 */

const STAGES: { title: string; desc: string }[] = [
  { title: 'Slowloris guard', desc: 'Drops slow-header clients before any rule runs (HTTP 408).' },
  { title: 'Bot management', desc: 'Verified-bot bypass → cookie/PoW challenge → escalating 429 → timed block.' },
  { title: 'Rate limiting', desc: 'Token-bucket per IP; bypass via IP / header / verified bot.' },
  { title: 'Threat scoring', desc: 'IP reputation, DDoS L7 & API-abuse signals; early 403 if score ≥ threshold.' },
  { title: 'Firewall rules (T0.5)', desc: 'Structured condition rules. Allow / Bypass short-circuits the WAF tiers.' },
  { title: 'Managed ruleset (T1)', desc: 'Vendor-maintained OWASP signature rules.' },
  { title: 'Global rules (T2)', desc: 'Account-wide wirefilter rules.' },
  { title: 'Custom rules (T3)', desc: 'Per-domain wirefilter rules.' },
  { title: 'AI ruleset (T4)', desc: '~2,280 ML-scored rules with their own threshold.' },
  { title: 'Access control', desc: 'Final Geo / IP / ASN / token allow-or-deny.' },
];

export function EdgePipelineExplainer() {
  return (
    <Explainer
      title="How the edge evaluates a request"
      description="10-stage pipeline — know the order before configuring rules"
    >
      <ol style={{ display: 'grid', gap: 10, margin: 0, padding: 0, listStyle: 'none' }}>
        {STAGES.map((s, i) => (
          <li key={s.title} style={{ display: 'flex', gap: 10, alignItems: 'flex-start' }}>
            <span
              style={{
                flexShrink: 0,
                width: 22,
                height: 22,
                borderRadius: 'var(--vn-radius-full)',
                background: 'var(--vn-bg-muted)',
                color: 'var(--vn-fg-muted)',
                fontSize: 12,
                fontWeight: 600,
                display: 'grid',
                placeItems: 'center',
              }}
            >
              {i + 1}
            </span>
            <span style={{ display: 'grid', gap: 1 }}>
              <span style={{ fontSize: 13, fontWeight: 500, color: 'var(--vn-fg-default)' }}>{s.title}</span>
              <span style={{ fontSize: 12, color: 'var(--vn-fg-muted)' }}>{s.desc}</span>
            </span>
          </li>
        ))}
      </ol>
    </Explainer>
  );
}
